export default __webpack_public_path__ + "static/media/il-serpente.e3373612.jpg";